/** @format */

/* eslint-disable */
import React from 'react'
import BreadCrumb from '../../../../../../Components/BreadCrumb/Index'
import ListRefundBatches from '../Partials/ListRefundBatches'
import localize from '../../../../../../Global/Localize'

function BatchOrigination() {
  return (
    <>
      <BreadCrumb
        tree={[
          localize('refundBatches'),
          localize('settlement'),
          localize('origination'),
        ]}
      />
      <div className="row">
        <ListRefundBatches refundBatchMode={'edit'} showAddButton />
      </div>
    </>
  )
}

export default BatchOrigination
